import { render, staticRenderFns } from "./EventOrganizerSelection.vue?vue&type=template&id=3f4fbb91"
import script from "./EventOrganizerSelection.vue?vue&type=script&lang=ts&setup=true"
export * from "./EventOrganizerSelection.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports